module.exports = __webpack_public_path__ + "static/media/slide-3.d4ca3571.jpg";